__turbopack_context__.v({
  "chevron": "dropdown-input-module-scss-module__l3g2lW__chevron",
  "content": "dropdown-input-module-scss-module__l3g2lW__content",
  "default": "dropdown-input-module-scss-module__l3g2lW__default",
  "destructive": "dropdown-input-module-scss-module__l3g2lW__destructive",
  "disabled": "dropdown-input-module-scss-module__l3g2lW__disabled",
  "placeholder": "dropdown-input-module-scss-module__l3g2lW__placeholder",
  "root": "dropdown-input-module-scss-module__l3g2lW__root",
  "success": "dropdown-input-module-scss-module__l3g2lW__success",
  "trigger": "dropdown-input-module-scss-module__l3g2lW__trigger",
  "trigger_inner": "dropdown-input-module-scss-module__l3g2lW__trigger_inner",
  "value": "dropdown-input-module-scss-module__l3g2lW__value",
  "value_wrapper": "dropdown-input-module-scss-module__l3g2lW__value_wrapper",
  "warning": "dropdown-input-module-scss-module__l3g2lW__warning",
});
